export const enterpriseAppName = 'enterprise-ui';
export const enterpriseBasename = 'enterprise/supplier';
